/* helpLinkMapping.js */

'use strict';
module.exports = {
    "defaultLink":"https://support.gluware.com/hc/en-us"
};

/**
 SD-WAN - https://support.gluware.com/hc/en-us/categories/115001458708-SD-WAN
 Advanced Control - https://support.gluware.com/hc/en-us/categories/115001937908-Advanced-Control
 Solutions Mgmt - https://support.gluware.com/hc/en-us/categories/115001897527-Solutions-Managment
 LAN Switching - https://support.gluware.com/hc/en-us/categories/115001926127-LAN-Switching
 Routing - https://support.gluware.com/hc/en-us/categories/115001921668-Routing
 OS Upgrade - https://support.gluware.com/hc/en-us/categories/115001937928-OS-Upgrade
 VNFusion - https://support.gluware.com/hc/en-us/categories/115001921688-VNFusion
 Workflows - https://support.gluware.com/hc/en-us/categories/115002375568-Workflows
 */
